export class ListItem {
    codigo   : string;
    descricao: string;
    selecionado  : boolean;
}
